import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import { Button, Card, Col, Container, Dropdown, Row} from "react-bootstrap";
import { axiosAuth_DATA_MGMT_API } from '../utils/AxoisUtilComponent';
import { useTranslation } from 'react-i18next';
import classes from './AdminPages.module.css';
import { isNaturalNumber } from '../utils/jsUtils';
import { translateAPIError } from '../utils/apiUtils';
import configInfo from '../config/config.json';


const LocationAdmin_NewLocationView = (props) => {

  // Utilities
  const { t } = useTranslation(['common', 'custom']);
  const navigate = useNavigate();

  // Initialize with actual JSON obj.  If not, will get error.
  const [locationAttrs, setLocationAttrs] = useState({
    id: '',
    code: '',
    description: '',
    site: '',
    building: '',
    wing: '',
    floor: '',
    room: '',
    roomType: '',
    roomSeq: null,
    externalSystemId: ''
  });

  const typeList = [
    { key: "CITY",     value: "CITY"     },
    { key: "DISTRICT", value: "DISTRICT" },
    { key: "NBHD",     value: "NBHD"     },
    { key: "SITE",     value: "SITE"     },
    { key: "BUILDING", value: "BUILDING" },
    { key: "WING",     value: "WING"     },
    { key: "FLOOR",    value: "FLOOR"    },
    { key: "ROOM",     value: "ROOM"     },
    { key: "CORRIDOR", value: "CORRIDOR" },
    { key: "ST",       value: "ST"       },
    { key: "AREA",     value: "AREA"     },
    { key: "CTYD",     value: "CTYD"     },
    { key: "BLDG_DR",  value: "BLDG_DR"  },
    { key: "INT_DR",   value: "INT_DR"   },
    { key: "LIFT",     value: "LIFT"     },
    { key: "OTHER",    value: "OTHER"    }
  ];

  // UI Functions

  const [errMsg, setErrMsg] = useState('');

  const onAttrsInputChange = (e) => {
    setLocationAttrs({ ...locationAttrs, [e.target.name]: e.target.value })
  }

  const onTypeClick = (key) => {
    setLocationAttrs({ ...locationAttrs, type: key })
  }

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!locationAttrs.code || locationAttrs.code.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_loc_code"));
    } else if (locationAttrs.code.length > 50) {
      setErrMsg(t("I18N_ERR_Max_len_code") + "50");
    } else {
      validateOtherFields();
    }

    return;
  }

  function validateOtherFields() {
    // Validate form inputs

    if (!locationAttrs.description || locationAttrs.description.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_description"));
    } else if (locationAttrs.description.length > 200) {
      setErrMsg(t("I18N_ERR_Max_len_desc") + "200");

    } else if (!locationAttrs.type || locationAttrs.description.type === 0) {
      setErrMsg(t("I18N_ERR_Need_type"));

    } else if (locationAttrs.name && (locationAttrs.name.length > 100)) {
      setErrMsg(t("I18N_ERR_Max_len_name") + "100");

    } else if (locationAttrs.nameLang2 && (locationAttrs.nameLang2.length > 100)) {
      setErrMsg(t("I18N_Name") + " (" + t("custom:I18N_Language_2") + ") - " + t("I18N_ERR_Max_len") + "100");

    } else if (locationAttrs.nameLang3 && (locationAttrs.nameLang3.length > 100)) {
      setErrMsg(t("I18N_Name") + " (" + t("custom:I18N_Language_3") + ") - " + t("I18N_ERR_Max_len") + "100");

    } else if (locationAttrs.site && (locationAttrs.site.length > 30)) {
      setErrMsg(t("I18N_ERR_Max_len_site") + "30");

    } else if (locationAttrs.building && (locationAttrs.building.length > 30)) {
      setErrMsg(t("I18N_ERR_Max_len_building") + "30");

    } else if (locationAttrs.wing && (locationAttrs.wing.length > 30)) {
      setErrMsg(t("I18N_ERR_Max_len_wing") + "30");

    } else if (locationAttrs.floor && (locationAttrs.floor.length > 30)) {
      setErrMsg(t("I18N_ERR_Max_len_floor") + "30");

    } else if (locationAttrs.room && (locationAttrs.room.length > 30)) {
      setErrMsg(t("I18N_ERR_Max_len_room") + "30");

    } else if (locationAttrs.roomType && (locationAttrs.roomType.length > 30)) {
      setErrMsg(t("I18N_ERR_Max_len_room_type") + "30");

    } else if (locationAttrs.roomSeq && (locationAttrs.roomSeq.length > 0) &&
               (!isNaturalNumber(locationAttrs.roomSeq) || (locationAttrs.roomSeq > 2147483647))) {
      setErrMsg(t("I18N_Room_seq") + t("I18N_ERR_Must_be_pos_int_and_LT") + '2,147,483,648.');
      return;

    } else if (locationAttrs.externalSystemId && (locationAttrs.externalSystemId.length > 30)) {
      setErrMsg(t("I18N_ERR_Max_len_ext_sys_id") + "30");

    } else {
      createNewLocation();
    }
  }

  const createNewLocation = () => {

    // Extract room type and room sequence from the location code

    // Make a deep copy
    const reqBody = JSON.parse(JSON.stringify(locationAttrs));

    // Convert roomSeq into integer type
    reqBody.roomSeq = locationAttrs.roomSeq && (locationAttrs.roomSeq.length > 0) ? (locationAttrs.roomSeq * 1.0) : null;

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.post("locations", reqBody);

        resolve(res.data);

        if (res.status === 201) {

          // Return to list
          navigate(-1);
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }
      }
    });
  }


  const handleCancel = (e) => {
    e.preventDefault();

    // Return to list
    navigate(-1);
  }


  return (
    <>
      <Card style={{overflow:'auto', border:'0', boxShadow:'0 2px 2px 0px rgba(0,0,0,0.1)',
                    padding:'20px 40px 20px 40px', maxWidth:'2500px', width:'100%', fontSize:'13px'}}>

        <div style={{display:'flex'}}>
        <span className={classes.admin_pages__page_title}>
          {t("I18N_New_Location")}
        </span>
        </div>

        <div className={classes.admin_pages__page_subtitle} style={{marginTop:'20px'}}>
          <div display='flex'>
            <span>
              {t("I18N_Location_info")}
            </span>
          </div>
          <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>
        </div>

        <Container>
          <form>
            <Row className={classes.admin_pages__field_label}>
              <Col sm={3}>{t("I18N_Code")}: *</Col>
              { configInfo.uiConfig.visibleFields.LOCATION_Name ?
                <Col sm={3}>{t("I18N_Name")}:</Col>
              : null
              }
              { configInfo.uiConfig.visibleFields.LOCATION_NameLang2 ?
                <Col sm={3}>{t("I18N_Name") + " (" + t("custom:I18N_Language_2") + ")"}:</Col>
              : null
              }
              { configInfo.uiConfig.visibleFields.LOCATION_NameLang3 ?
                <Col sm={3}>{t("I18N_Name") + " (" + t("custom:I18N_Language_3") + ")"}:</Col>
              : null
              }
            </Row>
            <Row className={classes.admin_pages__field_value}>
              <Col sm={3}>
                <input className={classes.admin_pages__field_editable} name="code" value={locationAttrs.code}
                  onChange={(e) => onAttrsInputChange(e)} />
              </Col>
              { configInfo.uiConfig.visibleFields.LOCATION_Name ?
                <Col sm={3}>
                  <input className={classes.admin_pages__field_editable} style={{width:'100%'}} name="name" value={locationAttrs.name}
                    onChange={(e) => onAttrsInputChange(e)} />
                </Col>
              : null
              }
              { configInfo.uiConfig.visibleFields.LOCATION_NameLang2 ?
                <Col sm={3}>
                  <input className={classes.admin_pages__field_editable} style={{width:'100%'}} name="nameLang2" value={locationAttrs.nameLang2}
                    onChange={(e) => onAttrsInputChange(e)} />
                </Col>
              : null
              }
              { configInfo.uiConfig.visibleFields.LOCATION_NameLang3 ?
                <Col sm={3}>
                  <input className={classes.admin_pages__field_editable} style={{width:'100%'}} name="nameLang3" value={locationAttrs.nameLang3}
                    onChange={(e) => onAttrsInputChange(e)} />
                </Col>
              : null
              }
            </Row>

            <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
              <Col sm={3}>{t("I18N_Description")}: *</Col>
              <Col sm={3}>{t("I18N_Type")}: *</Col>
              <Col sm={3}>{t("I18N_Ext_sys_id")}:</Col>
            </Row>
            <Row className={classes.admin_pages__field_value}>
              <Col sm={3}>
                <textarea className={classes.admin_pages__field_editable} style={{width:'100%'}} name="description" value={locationAttrs.description}
                  onChange={(e) => onAttrsInputChange(e)} />
              </Col>
              <Col sm={3}>
                <Dropdown>
                  <Dropdown.Toggle size="tiny_dropdown" variant="outline-secondary" className={classes.dropdown_item_wrap} id="dropdown-basic-button">
                    {!locationAttrs.type ? t("common:I18N_DROPDOWN_PROMPT") : t("common:I18N_LOC_TYPE_" + locationAttrs.type) }
                  </Dropdown.Toggle>
                  <Dropdown.Menu style={{ maxHeight: "200px", overflowY: "auto"}} id="dropdown-basic-button" >
                    {typeList.map((item, index) => {
                      return (
                        <Dropdown.Item key={index} eventKey={item.code} className={classes.dropdown_item_wrap} onClick={() => onTypeClick(item.key)}>
                          {t("common:I18N_LOC_TYPE_" + item.value)}
                        </Dropdown.Item>
                      );
                    })}
                  </Dropdown.Menu>
                </Dropdown>
              </Col>
              <Col sm={3}>
                <input className={classes.admin_pages__field_editable} name="externalSystemId" value={locationAttrs.externalSystemId}
                  onChange={(e) => onAttrsInputChange(e)} />
              </Col>
            </Row>

            <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
              <Col sm={3}>{t("I18N_Site")}:</Col>
              <Col sm={3}>{t("I18N_Building")}:</Col>
              <Col sm={3}>{t("I18N_Wing")}:</Col>
              <Col sm={3}>{t("I18N_Floor")}:</Col>
            </Row>
            <Row className={classes.admin_pages__field_value}>
              <Col sm={3}>
                <input className={classes.admin_pages__field_editable} name="site" value={locationAttrs.site}
                  onChange={(e) => onAttrsInputChange(e)} />
              </Col>
              <Col sm={3}>
                <input className={classes.admin_pages__field_editable} name="building" value={locationAttrs.building}
                  onChange={(e) => onAttrsInputChange(e)} />
              </Col>
              <Col sm={3}>
                <input className={classes.admin_pages__field_editable} name="wing" value={locationAttrs.wing}
                  onChange={(e) => onAttrsInputChange(e)} />
              </Col>
              <Col sm={3}>
                <input className={classes.admin_pages__field_editable} name="floor" value={locationAttrs.floor}
                  onChange={(e) => onAttrsInputChange(e)} />
              </Col>
            </Row>

            <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
              <Col sm={3}>{t("I18N_Room")}:</Col>
              <Col sm={3}>{t("I18N_Room_type")}:</Col>
              <Col sm={3}>{t("I18N_Room_seq")}:</Col>
            </Row>
            <Row className={classes.admin_pages__field_value}>
              <Col sm={3}>
                <input className={classes.admin_pages__field_editable} name="room" value={locationAttrs.room}
                  onChange={(e) => onAttrsInputChange(e)} />
              </Col>
              <Col sm={3}>
                <input className={classes.admin_pages__field_editable} name="roomType" value={locationAttrs.roomType}
                  onChange={(e) => onAttrsInputChange(e)} />
              </Col>
              <Col sm={3}>
                <input className={classes.admin_pages__field_editable} name="roomSeq" value={locationAttrs.roomSeq}
                  onChange={(e) => onAttrsInputChange(e)} />
              </Col>
            </Row>

            <hr className="solid" style={{ marginTop: '30px' }}></hr>

            <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px', fontStyle: 'italic' }}>
              <span>{t("I18N_Req_fields")}</span>
            </Row>

            <Row>
              <div display='flex' style={{ marginTop: '15px' }}>
                <Button size="sm" variant="outline-secondary" className="mb-3"
                  style={{ float: 'left' }}
                  onClick={handleCancel}>
                  {t("I18N_Cancel")}
                </Button>
                <Button size="sm" variant="outline-secondary" className="mb-3"
                  style={{ marginLeft: '15px' }}
                  onClick={handleSubmit}>
                  {t("I18N_Submit")}
                </Button>
                <span className={classes.admin_pages__field_label} style={{ marginLeft: '30px', color: 'rgba(200,0,0)', verticalAlign: 'top' }}>
                  {errMsg}
                </span>
              </div>
            </Row>
          </form>
        </Container>

      </Card>
    </>
  );
}

export default LocationAdmin_NewLocationView;
